/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatusSchema
 */
export interface StatusSchema {
    /**
     * 
     * @type {string}
     * @memberof StatusSchema
     */
    status: string;
}

/**
 * Check if a given object implements the StatusSchema interface.
 */
export function instanceOfStatusSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function StatusSchemaFromJSON(json: any): StatusSchema {
    return StatusSchemaFromJSONTyped(json, false);
}

export function StatusSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function StatusSchemaToJSON(value?: StatusSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

